export const parseReminderNotificationDate = (message: string): string | null => {
  const match = message.match(/^План на день \+ (\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return null;

  const [, day, month, year] = match;
  return `${year}-${month}-${day}`;
};
